import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  templateUrl: 'radio.component.html',
  selector: 'radio-component',
  styleUrls: ['radio.less']
})

export class RadioComponent {

  // constructor(){}

  @Input() possibleValues;

  @Input() selectedValue;

  @Input() shownProperty = 'name';

  @Input() modelName;

  @Input() columns;

  @Input() disabled = false;

  @Output() updateEmitter = new EventEmitter();


  private parseToDashCase(string) {
    // http://stackoverflow.com/questions/1983648/replace-space-with-dash-and-make-all-letters-lower-case-using-javascript
    return string.replace(/\s+/g, '-').toLowerCase();
  }

  /**
   * This function will be used in the view by every radiobutton element in the component.
   * It returns true if the current iteration of the loop should be checked.
   */
  private isChecked(valueToCheck) {
    if (this.selectedValue === null) {
      if (valueToCheck.id === null) {
        return true;
      } else {
        return false;
      }
    } else if (this.selectedValue.id === valueToCheck.id) {
      return true;
    }
  }

  private changeHandler($event, item){
    this.selectedValue = item;

    let updatedData;

    if (item.id === null) {
      updatedData = null;
    } else {
      updatedData = item;
    }

    // the parent component will use this object to update its model.
    const outputObj = {
      event: $event,
      updatedData: updatedData,
      model: this.modelName
    };

    this.updateEmitter.emit(outputObj);
  }
}



// WEBPACK FOOTER //
// ./src/app/_component/radio/radio.component.ts